import { Link } from 'react-router-dom'
import React from 'react'
import { Stack } from '@mui/system'
import { issueTags } from '../../components/Autocomplete'
import { HasWarrantLabel, KVLabel } from '../../components/entities/IssueTypeLabels'
import { GridRenderCellParams } from '@mui/x-data-grid/models'
import { EnrichedNewsItem } from './NewsItemsGrid'

const DateGroupItem = (props: GridRenderCellParams<EnrichedNewsItem> & { isSlim?: boolean }) => {
    const { row, isSlim } = props

    return (
        <>
            <div
                style={{
                    fontWeight: 400,
                    display: 'flex',
                    alignItems: isSlim ? undefined : 'center',
                    minHeight: '40px',
                }}
            >
                <Stack
                    alignItems={isSlim ? undefined : 'center'}
                    justifyContent='space-between'
                    direction='row'
                    spacing={2}
                    sx={{ display: 'flex', width: isSlim ? undefined : '200px' }}
                >
                    {!isSlim && (
                        <Link to={`/companies/${row.companyId}`}>
                            <span style={{ marginLeft: 30 }}>{row.symbol}</span>
                        </Link>
                    )}
                    <Stack
                        alignItems={isSlim ? undefined : 'center'}
                        direction='row'
                        justifyContent='flex-start'
                        spacing={1}
                        sx={{ display: 'flex', width: '65px' }}
                    >
                        {row.issueData ? (
                            issueTags({
                                issueType: row.issueData.type,
                                sharesInUnit: row.issueData.sharesInUnit,
                                hasWarrants: !!row.issueData.hasWarrants,
                                unitExtraContent: row.issueData.unitExtraContent,
                            })
                        ) : row.convertibleData ? (
                            <KVLabel />
                        ) : (
                            <HasWarrantLabel />
                        )}
                    </Stack>
                </Stack>
            </div>
        </>
    )
}

export default DateGroupItem
